import React from "react";
//import Accordion from "../Skills/Accordion.jsx";
import MultiActionAreaCard from "./MultiActionAreaCard.jsx";
import { dataArray } from "./objData.js";
import "./skills.css";




function Skills() {

    return (

        <section className="bg-blue-change flex justify-center py-6">
            <div className="flex flex-col w-full max-w-7xl px-3 lg:px-5">
                <div className="text-center">
                    <h1 className="text-4xl lg:text-5xl text-white my-4 font-black">Skills</h1>
                </div>
                {dataArray.map((group) => (
                    <div key={group.category} className="mb-6">
                        <h2 className="text-xl lg:text-2xl text-white font-bold mb-3">{group.category}</h2>
                        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6">
                            {group.items.map((element) => (
                                <MultiActionAreaCard
                                    key={`${group.category}-${element.language}`}
                                    icon={element.icon}
                                    title={element.language}
                                    text={element.description}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>

    )
}


export default Skills;
